import { css } from 'styled-components'

const media = {
  smallestScreen: (...args) =>
    css`
      @media (max-width: 359px) {
        ${css(...args)};
      }
    `,
  smallScreen: (...args) =>
    css`
      @media (max-width: 575px) {
        ${css(...args)};
      }
    `,
  mediumScreen: (...args) =>
    css`
      @media (min-width: 576px) and (max-width: 899px) {
        ${css(...args)};
      }
    `,
  largeScreen: (...args) =>
    css`
      @media (min-width: 900px) {
        ${css(...args)};
      }
    `,
  smallerThanLargeScreen: (...args) =>
    css`
      @media (max-width: 899px) {
        ${css(...args)};
      }
    `,
  largerThanSmallScreen: (...args) =>
    css`
      @media (min-width: 576px) {
        ${css(...args)};
      }
    `,
  smallerThanSmallScreen: (...args) =>
    css`
      @media (max-width: 399px) {
        ${css(...args)};
      }
    `,
  smallPhone: (...args) =>
    css`
      @media screen and (max-width: 360px), screen and (max-height: 640px) {
        ${css(...args)};
      }
    `,
}

export default media
